import React, { useEffect } from 'react'

import CouponSuccessModal from './successModal'
import type { CouponSuccessModalProps } from './types'

interface CouponSuccessModalWrapperProps extends CouponSuccessModalProps {
    autoCloseDelay?: number
}

const CouponSuccessModalWrapper: React.FC<CouponSuccessModalWrapperProps> = ({
    open,
    successMessage,
    onClose,
    animationData,
    autoCloseDelay = 0
}) => {
    // ✅ ALL business logic here - following CODEBASE_CONTEXT guidelines

    // Auto-close timer
    useEffect(() => {
        if (!open) return

        const timer = setTimeout(() => {
            onClose()
        }, autoCloseDelay)

        return () => clearTimeout(timer)
    }, [open, onClose, autoCloseDelay])

    return (
        <CouponSuccessModal
            open={open}
            successMessage={successMessage}
            onClose={onClose}
            animationData={animationData}
        />
    )
}

export default CouponSuccessModalWrapper
export type { CouponSuccessModalWrapperProps }
